module.exports = __webpack_public_path__ + "media/customizations/libertyatlincoln/logo-new-465f3a6586cfba4d018e18c391958370.png";